import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import WelcomePage from './components/WelcomePage';
import QuestionnairePage from './components/QuestionnairePage';
import ResultsPage from './components/ResultsPage';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProgressBar from './components/ProgressBar';
import { QuestionnaireProvider } from './context/QuestionnaireContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return user ? children : <Navigate to="/admin/login" />;
}

function App() {
  const [currentStep, setCurrentStep] = useState(0);
  const [totalSteps] = useState(12);

  return (
    <AuthProvider>
      <QuestionnaireProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
            <div className="container mx-auto px-4 py-8">
              <Routes>
                <Route 
                  path="/" 
                  element={
                    <div className="max-w-4xl mx-auto">
                      <WelcomePage />
                    </div>
                  } 
                />
                <Route 
                  path="/questionnaire" 
                  element={
                    <div className="max-w-4xl mx-auto">
                      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
                      <QuestionnairePage 
                        currentStep={currentStep} 
                        setCurrentStep={setCurrentStep}
                        totalSteps={totalSteps}
                      />
                    </div>
                  } 
                />
                <Route 
                  path="/results" 
                  element={
                    <div className="max-w-6xl mx-auto">
                      <ResultsPage />
                    </div>
                  } 
                />
                <Route 
                  path="/admin/login" 
                  element={<AdminLogin />} 
                />
                <Route 
                  path="/admin/dashboard" 
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </div>
          </div>
        </Router>
      </QuestionnaireProvider>
    </AuthProvider>
  );
}

export default App;